import React from 'react';
import { Controller } from 'react-hook-form';
import DateRangePicker from '../../../date-range-picker/date-range-picker';
import dayjs from 'dayjs';
import Typography from '../../../typography/typography';


interface DateRangePickerProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  formType?: string;
}

const DynamicDateRange = (props: DateRangePickerProps) => {
    const minDate = dayjs(props.min_date || null).isValid()
        ? dayjs(props.min_date).toDate()
        : null;

    const maxDate = dayjs(props.max_date || null).isValid()
        ? dayjs(props.max_date).toDate()
        : null;

    return (
        <Controller
            control={props.formControl}
            name={`${props.fieldArrayName}.${props.name}`}
            render={({ field, fieldState }) => (
                <>
                    {props?.label &&
                        <Typography
                            type='s5'
                            weight='medium'
                            mb={0.5}
                            color={props.error ? 'theme.error.600' : 'theme.secondary.800'}

                        >
                            {props.label}
                            {props.required && <span className='requiredStar'>*</span>}
                        </Typography>}

                    <DateRangePicker
                        start={field.value?.[0]}
                        end={field.value?.[1]}
                        startYear={props.startYear || 1980}
                        onDateRangeChange={(dates: [Date | null, Date | null]) => {
                            field.onChange(dates);
                            if (props.onChange) {
                                props.onChange(dates);
                            }
                        }}
                        placeholderText={props.placeholder || "MM-DD-YYYY - MM-DD-YYYY"}
                        dataPosition={props.position}
                        dataName={`${props.fieldArrayName}.${props.name}`}
                        label={props.label}
                        required={props.formType === 'builder' ? false : props.required}
                        minDate={minDate}
                        maxDate={maxDate}
                        disabled={props.disabled}
                        error={Boolean(fieldState.error)}
                        helperText={fieldState.error?.message}
                    />
                </>
            )}
        />
    );
};
export { DynamicDateRange };
export default DynamicDateRange;